import { render, staticRenderFns } from "./ResumoDetalhes.vue?vue&type=template&id=245fb0fe&"
import script from "./ResumoDetalhes.vue?vue&type=script&lang=js&"
export * from "./ResumoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ResumoDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports